// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"cFbgg","background":"gELXr","icon":"GLDVA","background-invert":"osKnK"};